<template>
  
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10Z" fill="#2E2E2E"/><path d="M10.75 7C10.75 6.80109 10.671 6.61032 10.5303 6.46967C10.3897 6.32902 10.1989 6.25 10 6.25C9.80109 6.25 9.61032 6.32902 9.46967 6.46967C9.32902 6.61032 9.25 6.80109 9.25 7V9.25H7C6.80109 9.25 6.61032 9.32902 6.46967 9.46967C6.32902 9.61032 6.25 9.80109 6.25 10C6.25 10.1989 6.32902 10.3897 6.46967 10.5303C6.61032 10.671 6.80109 10.75 7 10.75H9.25V13C9.25 13.1989 9.32902 13.3897 9.46967 13.5303C9.61032 13.671 9.80109 13.75 10 13.75C10.1989 13.75 10.3897 13.671 10.5303 13.5303C10.671 13.3897 10.75 13.1989 10.75 13V10.75H13C13.1989 10.75 13.3897 10.671 13.5303 10.5303C13.671 10.3897 13.75 10.1989 13.75 10C13.75 9.80109 13.671 9.61032 13.5303 9.46967C13.3897 9.32902 13.1989 9.25 13 9.25H10.75V7Z" fill="white" fill-opacity="0.4"/></svg>       
    
</template>
<script>


/*

    <file close @close="close" ></file>
 
*/

export default {
    data: function () {return {
        preview: false,
    }},
    props:{
        close: Boolean,
        width:{type:String, default:'65px'},
        height:{type:String, default:'65px'},
        file: {},
    },    
    computed: {
      icon(){
        let ext = this.tools.ext(this.file.name)
        ext = ext.toUpperCase()
        return `/images/icons/file/${ext || 'TXT'}.svg`        
      },
      title(){
        return this.file.name
      },
      info(){
        return this.tools.size( this.file.size)
      },
    },
    methods: {
      remove(){
            this.$emit('close', true);
        }
    },
}
</script>

<style scoped>
.fileTitle {
  font-size: 11px;
  word-break: break-all;
  text-align: center;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10ch;  */

  overflow: hidden;
    display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 14px;
  color: var(--g5);
}
.fileDesc {
  font-size: 10px;
  color: var(--g2);
}


.closeIcon {
  width: 22px;
  height: 22px;
  background: #222222;
  position: absolute;
  top: 0;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
}

.closeIcon:hover {
  background: #a74c4c;
}

.closeIcon::after {
  content: '×';
  color: var(--g5);
  font-size: 13px;
  font-weight: 600;
  margin-top: -1px;
}

.closeIcon:hover::after {
  color: var(--g9);
}
</style>

